<template>
    <div  class="page register-page">
        <Header title="账号注册" :show-back="true" class="nav" />
        <div class="content" v-if="applyType==='01'">
            <div class="notice-bar">
              <div class="notice-bar-info">提示：请注意输入的信息是否正确</div>
            </div>
            <van-form @submit="onSubmit" ref="submitForm" :show-error="false">
              <van-field
                v-model.trim="params.applyInviteCode"
                name="推荐码"
                label="推荐码(非必填)"
                placeholder="请输入推荐码"
              />
              <van-field
                v-model.trim="params.clientName"
                name="公司名称"
                label="公司名称"
                placeholder="请输入公司名称"
                :rules="[{ required: true, message: '请输入公司名称' }]"
              />
              <van-field v-model="params.contactMobile" type="tel" label="手机号"
                placeholder="请输入手机号"
                :rules="rules.mobileRule">
                  <template #button>
                    <div :style="disableSendBtn?'color:grey':'color:#00545e'" @click="handleRegisterCheck">获取验证码{{countDownText}}</div>
                  </template>
              </van-field>
              <van-field v-model="params.verifyCode" type="number" label="验证码"
                placeholder="请输入验证码"
                :rules="[{ required: true, message: '请输入验证码' }]" />
              <van-field
                v-model.trim="params.contactPerson"
                name="姓名"
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
                :disabled='userNameDisabled'
              />
              <van-field v-model="params.contactEmail" label="邮箱"
                placeholder="请输入邮箱"
                :rules="rules.emailRule" />
              <van-field
                readonly
                clickable
                label="城市"
                :value="value"
                placeholder="选择城市"
                @click="$refs.popupAddress.open(params.provinceId,params.cityId,params.countyId)"
                :rules="rules.cityRule"
              />
              <van-field v-show="value!==''" v-model.trim="params.detailAddress" label="详细地址"
                placeholder="请输入详细地址"
                :rules="[{ required: true, message: '请输入详细地址' }]" />

              <div class="register-field">
                <div class="register-field-title">请上传申请表</div>
                <!-- <div class="field-btn">下载申请表</div> -->
                <van-uploader v-model="fileList" :max-count="1" :after-read="afterRead" @delete="handleDelete">
                  <div class="upload-icon"> + </div>
                </van-uploader>
              </div>
              <div style="margin: 16px;">
                <van-button color="#00545e" block type="info" native-type="submit">立即注册</van-button>
              </div>
            </van-form>
        </div>

        <div v-if="applyType==='04'&&clientId===''">
          <van-search
            v-model="queryParam"
            show-action
            shape="round"
            background="#f1f1f1"
            placeholder="请输入店主手机号/修理厂编码/修理厂名称"
            @search="onSearch"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
          <div class="select-box" v-if="clientList.length!==0">
            <div class="select-item" @click="selectClientId(item)" v-for="item of clientList" :key="item.clientCode">
              <div class="select-item-info">{{item.clientName}}({{item.contactMobile&&maskedMobile(item.contactMobile)}})</div>
              <div class="select-item-code">修理厂编码:{{item.clientCode}}</div>
            </div>
          </div>
          <div class="no-data" v-if="noData">
            暂无信息
          </div>
        </div>

        <div class="content" v-if="applyType==='04'&&clientId!==''">
            <div class="notice-bar">
              <div class="notice-bar-info">提示：提交申请后72小时内需老板/客服审核，若超时未审核，则该条申请作废！</div>
            </div>
            <van-form @submit="onSubmit" ref="submitForm" :show-error="false">
              <van-field
                v-model="params.clientName"
                name="公司名称"
                label="公司名称"
                placeholder="请输入公司名称"
                :rules="[{ required: true, message: '请输入公司名称' }]"
                :disabled="applyType==='04'"
              />
              <van-field
                v-model.trim="params.contactPerson"
                name="姓名"
                label="姓名"
                placeholder="请输入姓名"
                :rules="[{ required: true, message: '请输入姓名' }]"
              />
              <van-field v-model="params.password" label="密码"
                placeholder="请输入密码" type="password"
                :rules="rules.passwordRule" />
              <van-field v-model="params.passwordAgain" label="确认密码"
                placeholder="请再次输入密码" type="password"
                :rules="rules.passwordAgainRule" />
              <van-field v-model="params.contactMobile" type="tel" label="手机号"
                placeholder="请输入手机号"
                :rules="rules.mobileRule">
                  <template #button>
                    <div :style="disableSendBtn?'color:grey':'color:#00545e'" @click="handleRegisterCheck">获取验证码{{countDownText}}</div>
                  </template>
              </van-field>
              <van-field v-model="params.verifyCode" type="number" label="验证码"
                placeholder="请输入验证码"
                :rules="[{ required: true, message: '请输入验证码' }]" />
              <div style="margin: 16px;">
                <van-button color="#00545e" block type="info" v-points native-type="submit">立即注册</van-button>
              </div>
            </van-form>
        </div>

        <!-- <van-popup v-model="showPicker" round position="bottom">
          <ChooseCity @cancleChooseCity="cancleChooseCity" @submitAddress="submitAddress"></ChooseCity>
        </van-popup> -->
        <PopupAddress ref="popupAddress" @setLocation="setLocation"></PopupAddress>

        <div class="block"></div>

        <van-overlay :show="registerOverlay" @click="registerOverlay = false">
          <div class="wrapper-overlay" @click.stop>
            <div class="content-overlay">
              <div class="overlay-cancel" @click="registerOverlay = false">x</div>
              <div class="content-title">注册申请已提交</div>
              <div class="content-info">
                <van-icon class="overlay-icon" name="passed" size="40" color="#00545e"/>
                <div>等待客服审核</div>
                <div>我们将以短信形式通知您审核结果</div>
              </div>
              <div class="overlay-btn" @click="registerOverlay=false">确定</div>
              <!-- <img src="../dialog-bg.png"></img> -->
            </div>
          </div>
        </van-overlay>

        <van-overlay :show="selectOverlay" @click="selectOverlay = false">
          <div class="wrapper-overlay" @click.stop>
            <div class="content-overlay">
              <div class="overlay-cancel" @click="selectOverlay = false">x</div>
              <div class="content-title">手机号已绑定修理厂</div>
              <div class="content-info content-info-client" v-for="(item,index) of clientList" :key="index">
                <div class="content-info-client-left">
                  <div class="content-info-client-name">{{item.clientName}}</div>
                  <div class="content-info-client-code">{{item.clientCode}}</div>
                </div>
                <div class="content-info-client-right" @click="gotoLogin(item.contactMobile,item.clientId)">
                  <div>选择</div>
                  <div>登录</div>
                </div>
              </div>
              <div class="overlay-btn" @click="getVerifyCode">继续注册</div>
              <!-- <img src="../dialog-bg.png"></img> -->
            </div>
          </div>
        </van-overlay>

    </div>
</template>

<script>
import Header from '@/components/header'
import centerApi from '../../api/center'
import activityApi from '../../api/activity'
import fileApi from '../../api/file'
import validators from '@/utils/validators'
import { cryptoUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
// import ChooseCity from './choose-city.vue'
import PopupAddress from '@/components/popup-address.vue'
export default {
  components: {
    Header,
    // ChooseCity,
    PopupAddress
  },
  data () {
    var checkPassword = validators.checkPassword
    var checkEmail = validators.checkEmail
    var checkMobile = validators.checkMobile
    var checkPasswordAgain = (val) => {
      if (val !== this.params.password) {
        return false
      }
    }
    return {
      params: {
        applyType: '01',
        verifyCode: '',
        applyInviteCode: '',
        clientName: '',
        contactPerson: '',
        contactMobile: '',
        detailAddress: '',
        contactEmail: '',
        authorizeFileId: '',
        password: '',
        passwordAgain: '',
        clientId: ''
      },
      detailAddress: '',
      showArea: false,
      areaList: {},
      showPicker: false,
      value: '',
      fileList: [],
      authorizeFileId: '',
      disableSendBtn: false,
      countDownIndex: 0,
      registerOverlay: false,
      selectOverlay: false,
      clientList: [],
      applyType: '01',
      queryParam: '',
      clientId: '',
      noData: false,
      rules: {
        passwordRule: [{ required: true, validator: checkPassword, message: '密码必须由8-12位数字,大小写字母和特殊字符其中三种组成' }],
        passwordAgainRule: [{ required: true, validator: checkPasswordAgain, message: '两次密码输入不一致' }],
        mobileRule: [{ required: true, validator: checkMobile, message: '请输入正确手机号' }],
        emailRule: [{ required: true, validator: checkEmail, message: '请输入正确邮箱' }],
        cityRule: [{ required: true, validator: this.checkCity, message: '请选择市' }]
      },
      userNameDisabled: false
    }
  },
  computed: {
    countDownText () {
      return this.countDownIndex > 0 ? '(' + this.countDownIndex + ')' : ''
    }
  },
  created () {
    this.applyType = this.$route.query.applyType
    this.clientId = this.$route.query.clientId || ''
    if (this.clientId !== '') {
      this.params.clientId = this.clientId
      let params = {
        clientId: this.clientId
      }
      centerApi.publicWorkshopQuery(params).then(res => {
        if (res.data.resultCode === '0') {
          this.params.clientName = res.data.resultData.clientList[0].clientName
        }
      })
    }
    this.params.applyType = this.$route.query.applyType
  },
  methods: {
    maskedMobile (mobile) {
      return mobile.substring(0, 3) + '****' + mobile.substring(7)
    },
    validator (val) {
      if (val === '' || this.params.passwordAgain === '') {
        return false
      } else if (val !== this.params.password) {
        return false
      }
    },
    handleDelete () {
      this.params.authorizeFileId = ''
    },
    onSubmit () {
      console.log(this.params)
      if (this.applyType === '01') {
        if (!this.params.authorizeFileId) {
          this.$toast('请上传申请表！')
          return
        }
        centerApi.registerSubmit(this.params).then(res => {
          if (res.data.resultCode === '0') {
            this.$dialog.alert({
              title: '提示',
              message: '注册申请提交成功！'
            }).then(() => {
              userUtils.removeUserLocal()
              this.$store.commit('setClientInfo', {})
              this.$router.push({ name: 'home-main' })
            })
          }
        })
      } else if (this.applyType === '04') {
        let params = this.params
        params.password = cryptoUtils.AESEncrypt(this.params.password)
        params.passwordAgain = cryptoUtils.AESEncrypt(this.params.passwordAgain)
        centerApi.registerWorkerSubmit(params).then(res => {
          if (res.data.resultCode === '0') {
            this.inviteFinsh()
            this.$dialog.alert({
              title: '提交成功',
              message: '注册申请提交成功，提交申请后72小时内需老板/客服审核，若超时未审核，则该条申请作废！'
            }).then(() => {
              userUtils.removeUserLocal()
              this.$store.commit('setClientInfo', {})
              this.$router.push({ name: 'home-main' })
            })
          }
        })
      }
    },
    // 易卡送福利活动邀请成功
    inviteFinsh () {
      let params = {
        userMobile: this.params.contactMobile,
        clientId: this.clientId
      }
      activityApi.inviteFinsh(params).then(res => {
        if (res.data.resultCode === '0') {
          console.log(res)
        }
      })
    },
    gotoLogin (contactMobile, clientId) {
      this.$router.push({ name: 'login2', query: { contactMobile, clientId } })
    },
    handleRegisterCheck () {
      centerApi.registerCheck(this.params).then(res => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData && res.data.resultData.clientList) {
            this.clientList = res.data.resultData.clientList
            this.selectOverlay = true
            this.userNameDisabled = true
            this.params.contactPerson = this.clientList[0].contactPerson
          } else {
            this.userNameDisabled = false
            this.getVerifyCode()
          }
        }
      })
    },
    getVerifyCode () {
      this.selectOverlay = false
      if (this.disableSendBtn) {
        return
      }
      let params = {
        phoneNumber: this.params.contactMobile
      }
      centerApi.publicRegisterVerifyCode(params).then(res => {
        if (res.data.resultCode === '0') {
          this.countDownIndex = 60
          this.disableSendBtn = true
          this.countDown()
        }
      })
    },
    countDown () {
      this.countDownIndex = 60
      let _vm = this
      let timer = setInterval(() => {
        _vm.countDownIndex--
        if (_vm.countDownIndex === 0) {
          _vm.disableSendBtn = false
          clearInterval(timer)
        }
      }, 1000)
    },
    afterRead (file) {
      fileApi
        .uploadFilePublic(file.file)
        .then((response) => {
          if (response.data.resultCode === '0') {
            let fileDTO = response.data.resultData.fileDTO
            this.params.authorizeFileId = fileDTO.fileId
          }
        })
        .catch(() => {
        })
    },
    // submitAddress (params) {
    //   this.params.provinceId = params.provinceId
    //   this.params.cityId = params.cityId
    //   this.params.countyId = params.countyId
    //   this.value = params.value
    //   this.showPicker = false
    // },
    handleCancelAddress () {
      this.value = ''
      this.showPicker = false
    },
    onSearch () {
      let params = {
        queryParam: this.queryParam
      }
      centerApi.publicWorkshopQuery(params).then(res => {
        if (res.data.resultCode === '0') {
          const { clientList } = res.data.resultData
          this.clientList = clientList || []
          this.noData = !this.clientList.length
        }
      })
    },
    selectClientId (item) {
      this.clientId = item.clientId
      this.params.clientId = item.clientId
      this.params.clientName = item.clientName
    },
    // cancleChooseCity () {
    //   this.showPicker = false
    // },
    setLocation (value) {
      this.params.provinceId = value.provinceId
      this.params.cityId = value.cityId
      this.params.countyId = value.countyId
      this.value = value.location
    },
    checkCity () {
      return Boolean(this.params.cityId)
    }
  }
}
</script>
<style lang="less" scoped>

.register-field{
  margin:20px  15px;
  .register-field-title{
    font-weight:bolder;
    font-size: 16px;
  }
}
.field-btn{
  position: absolute;
  right: 15px;
  line-height: 40px;
  color:#00545e
}
.notice-bar{
  display: flex;
  background-color: rgb(238, 236, 203);
  padding: 6px 10px;
  color: rgb(182, 157, 16);
  margin:15px;
  width: calc(100% - 50px);
  border-radius: 5px;
  justify-content: space-between;
}
.upload-icon{
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: dashed 2px rgb(190, 190, 190);
  font-size: 30px;
  text-align: center;
  color: rgb(190, 190, 190);
}
.van-uploader{
  margin-top: 15px;
}
.wrapper-overlay{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
.content-overlay{
  background-image: url(../../assets/images/dialog-bg.png);
  background-size: 100%;
  background-repeat: no-repeat;
  width: 80%;
  background-color: #fff;
  border-radius: 14px;
  img{
    width: 100%;
  }
  .overlay-cancel{
    color: #fff;
    font-size: 20px;
    position: absolute;
    right: 14%;
    margin-top: 10px;
  }
  .content-title{
    font-size: 19px;
    text-align: center;
    color: white;
    margin: 25px 0 15px 0;
  }
  .content-info{
    background-color: rgb(255, 255, 255);
    width: 86%;
    margin-left: 7%;
    z-index: 10;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    box-shadow: 0px 0px 0px 0px #f1f1f1,
    0px 0px 2px 0px #f1f1f1,
    0px 0px 2px 0px #f1f1f1,
    0px 2px 13px 0px #f1f1f1;
    .overlay-icon{
      padding-top: 20px;
    }
  }
    .overlay-btn{
    text-align: center;
    font-size: 18px;
    color: var(--base-green);
    padding: 15px 0 20px 0;
  }
  .content-info-client{
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    text-align: left !important;
    color: var(--base-green);
    font-size: 14px;
    padding-left: 10px;
  }

  .content-info-client-name{
    font-weight: 600;
  }
  .content-info-client-right{
    font-size: 14px;
    line-height: 18px !important;
    padding: 15px 10px 0 0 ;
  }
  .content-info-client-code{
    font-size: 12px;
  }
}
.select-item{
  width: 90%;
  margin: 10px 5%;
  line-height:20px;
}
.select-item-info{
  font-weight: 600;
}
.select-item-code{
  color: grey;
}
.no-data{
  margin-top: 30px;
  text-align: center;
  color: grey;
}
.block{
  width: 100%;
  height: 10px;
}
</style>
